import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Avatar from '@mui/material/Avatar';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));


export default function Header() {
  const appMode = useSelector((state) => state.mode.mode);
  const notifications = useSelector((state) => state.notifications.notifications);

  const dispatch = useDispatch();

  
 

  const toggleSidebar = () => {
    const event = new Event("toggleSideBar");
    window.dispatchEvent(event);
  }
  const user = useSelector((state) => state.user.user);

  return (
    <Box  sx={{ flexGrow: 1, position: 'fixed', zIndex: 1500, width: '100%' }}>
      <AppBar position="static" color='custom' enableColorOnDark={false}>
        <Toolbar>
        
        {appMode === 'dark' ? 
          <img style={{height: "40px"}} alt="BETA TRADES Logo" src="https://res.cloudinary.com/dyz8kppso/image/upload/v1754223144/logo_m53ie7.png" />

          :
          
          <img style={{height: "40px"}} alt="BETA TRADES Logo" src="https://res.cloudinary.com/dyz8kppso/image/upload/v1754223144/logo_m53ie7.png" />

          }
         

          <Box sx={{ flexGrow: 1 }} />
          
          
          <Box sx={{ display: { xs: 'flex', md: 'flex' } }}>
            

            <IconButton
              component={RouterLink} to="/notifications"
              size="large"
              aria-label="show notofocations"
              color="inherit"
            >
              <Badge badgeContent={notifications.length} color="error">
                <NotificationsIcon />
              </Badge>
            </IconButton>

            
          </Box>
          

          <IconButton
            onClick={toggleSidebar}
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ ml: 2, display: {md: 'none'} }}
          >
            <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754393437/menu-white_l9kiu6_rrjrrh.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754393187/menu-white_l9kiu6_iuv84w.png'} sx={{ padding: '5px', width: 38, height: 38, bgcolor: 'primary', color: '#fff'}}>
            </Avatar> 
          </IconButton>

        </Toolbar>
      </AppBar>
    </Box>
  );
}